import { Fragment } from 'react'
import styled from 'styled-components'
import { FormattedMessage, useIntl } from 'react-intl'
import { isEmpty } from 'lodash'

import { FormattedDate } from '@10xLabs/react-web/components/FormattedDate'
import { FormattedPrice } from '@10xLabs/react-web/components/FormattedPrice'
import { FormattedTimeByDate } from '@10xLabs/react-web/components/FormattedTimeByDate'
import { Table, Thead, Th, Tbody, Tr, Td } from '@10xLabs/react-web/components/Table'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { AddOutlineIcon } from '@10xLabs/react-web/components/Icons/AddOutline'
// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
import { RemoveOutlineIcon } from '@10xLabs/react-web/components/Icons/RemoveOutline'
import { round } from 'utils/math'

const DateWrapper = styled.div<TSFixMe>`
  display: flex;
  margin-bottom: 20px;
`

const CreatedAtWrapper = styled.div<TSFixMe>`
  font-weight: 500;
`

const ActionsWrapper = styled.div<TSFixMe>`
  display: flex;
`

const CountWrapper = styled.div<TSFixMe>`
  margin: 0 5px;
  border-radius: 8px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.05);
  border: solid 1px #575757;
  width: 40px;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
`

const StyledTd = styled(Td)<TSFixMe>`
  vertical-align: middle;
`

const Tf = styled.td<TSFixMe>`
  padding: 15px 0;
  text-align: right;
  border-top: 2px solid #1b1b3d;
`

const TotalWrapper = styled.div<TSFixMe>`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
`

const TotalLabel = styled.div<TSFixMe>`
  font-size: 16px;
  font-weight: 500;
  color: #1b1b3d;
  margin-right: 20px;
`

const TotalPrice = styled.div<TSFixMe>`
  font-size: 24px;
  font-weight: 500;
  color: #1b1b3d;
`

const CountButton = styled.button<TSFixMe>`
  border-radius: 19px;
  border: solid 2px ${(props): TSFixMe => (props.disabled ? '#575757' : '#1976d2')};
  padding: 7px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: ${(props): TSFixMe => (props.disabled ? 'not-allowed' : 'pointer')};
  color: ${(props): TSFixMe => (props.disabled ? '#575757' : '#1976d2')};
  background-color: transparent;

  svg {
    fill: ${(props): TSFixMe => (props.disabled ? '#575757' : '#1976d2')};
  }
`

const StyledTr = styled(Tr)<TSFixMe>`
  background: ${(props): TSFixMe => (props.isEven ? '#f8f9fc' : '#ffffff')}!important;
`

const ComboComponentName = styled.div<TSFixMe>`
  margin-left: 30px;
`

const ComponentTd = styled(Td)<TSFixMe>`
  padding-top: 0;
`

export const PartialCancellation = ({ sale, lineItems, setLineItems }: TSFixMe): TSFixMe => {
  const intl = useIntl()

  const newTotal = lineItems.reduce((result: TSFixMe, item: TSFixMe): TSFixMe => {
    return round(result + (item.quantity - item.cancelledQuantity) * item.unitPrice)
  }, 0)

  return (
    <div>
      <DateWrapper>
        <CreatedAtWrapper>
          <FormattedMessage id="sale.cancellation.partial.createdAt" defaultMessage="Fecha de pago:" />
        </CreatedAtWrapper>
        &nbsp;
        <FormattedDate intl={intl} value={sale.createdAt} month="2-digit" day="2-digit" year="numeric" />
        &nbsp;
        <FormattedTimeByDate intl={intl} date={sale.createdAt} />
      </DateWrapper>

      <Table>
        <Thead>
          <Tr>
            <Th>
              <FormattedMessage id="dictionary.product" defaultMessage="Producto" />
            </Th>

            <Th>
              <FormattedMessage id="dictionary.quantity" defaultMessage="Cantidad" />
            </Th>

            <Th>
              <FormattedMessage id="itemsSales.lineItems.sellingPrice.label" defaultMessage="Precio" />
            </Th>

            <Th>
              <FormattedMessage id="dictionary.total" defaultMessage="Total" />
            </Th>

            <Th>
              <FormattedMessage id="sale.cancellation.quantity" defaultMessage="Cantidad cancelada" />
            </Th>
          </Tr>
        </Thead>

        <Tbody>
          {lineItems.map((item: TSFixMe, index: number): TSFixMe => {
            const removeCancelledItem = (): TSFixMe => {
              setLineItems(
                lineItems.map((lineItem: TSFixMe): TSFixMe => {
                  if (lineItem.id === item.id) {
                    return {
                      ...lineItem,
                      cancelledQuantity: lineItem.cancelledQuantity - 1
                    }
                  }

                  return lineItem
                })
              )
            }

            const addCancelledItem = (): TSFixMe => {
              setLineItems(
                lineItems.map((lineItem: TSFixMe): TSFixMe => {
                  if (lineItem.id === item.id) {
                    return {
                      ...lineItem,
                      cancelledQuantity: lineItem.cancelledQuantity + 1
                    }
                  }

                  return lineItem
                })
              )
            }

            const itemIsCombo = !isEmpty(item.comboComponents)
            const isEven = (index + 1) % 2 === 0

            return (
              <Fragment key={index}>
                <StyledTr isEven={isEven}>
                  <StyledTd>
                    <div>{item.name}</div>
                  </StyledTd>

                  <StyledTd>{item.quantity}</StyledTd>

                  <StyledTd>
                    <FormattedPrice value={item.unitPrice} />
                  </StyledTd>

                  <StyledTd>
                    <FormattedPrice value={item.total} />
                  </StyledTd>

                  <StyledTd>
                    <ActionsWrapper>
                      <CountButton
                        type="button"
                        disabled={item.cancelledQuantity <= 0}
                        // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                        onClick={(): TSFixMe => removeCancelledItem(item)}
                      >
                        <RemoveOutlineIcon />
                      </CountButton>

                      <CountWrapper>{item.cancelledQuantity}</CountWrapper>

                      <CountButton
                        type="button"
                        disabled={item.cancelledQuantity >= item.quantity}
                        onClick={(): TSFixMe => {
                          if (item.cancelledQuantity < item.quantity) {
                            // @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
                            addCancelledItem(item)
                          }
                        }}
                      >
                        <AddOutlineIcon />
                      </CountButton>
                    </ActionsWrapper>
                  </StyledTd>
                </StyledTr>

                {itemIsCombo && (
                  <>
                    {item.comboComponents.map((component: TSFixMe, componentIndex: number): TSFixMe => {
                      return (
                        <StyledTr key={componentIndex} isEven={isEven}>
                          <ComponentTd>
                            <ComboComponentName>{component.item.name}</ComboComponentName>
                          </ComponentTd>

                          <ComponentTd>{round(item.quantity * component.quantity)}</ComponentTd>

                          <ComponentTd />

                          <ComponentTd />
                        </StyledTr>
                      )
                    })}
                  </>
                )}
              </Fragment>
            )
          })}
        </Tbody>

        <tfoot>
          <tr>
            <Tf colSpan={5}>
              <TotalWrapper>
                <TotalLabel>
                  <FormattedMessage id="items.sale.preview.total.label" defaultMessage="Total de la venta:" />
                </TotalLabel>

                <TotalPrice>
                  <FormattedPrice value={newTotal} />
                </TotalPrice>
              </TotalWrapper>
            </Tf>
          </tr>
        </tfoot>
      </Table>
    </div>
  )
}
